import { render, staticRenderFns } from "./FormRadioItem.vue?vue&type=template&id=3ee4fd10&"
import script from "./FormRadioItem.vue?vue&type=script&lang=js&"
export * from "./FormRadioItem.vue?vue&type=script&lang=js&"
import style0 from "./FormRadioItem.vue?vue&type=style&index=0&id=3ee4fd10&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports